export default __webpack_public_path__ + "static/media/survey form.abd9a4a2.PNG";